import moment from 'moment';
import accounting from 'accounting';


export function transformDate(dateStr, format = 'MMM D, YYYY', inputFormat) {
  if (!dateStr) {
    return dateStr;
  }

  return moment(dateStr, inputFormat).format(format);
}

export function addPriceSymbol(price) {
  if (!price && price !== 0) {
    return price;
  }

  return accounting.formatMoney(price);
}

export function isNumeric(value) {
  return !isNaN( parseFloat( value ) ) && isFinite( value );
}

export function twoDigitsNumber(num) {
  return (+num).toFixed(2);
}

export function calcPercentage(whole, part) {
  if (isNumeric(whole) && isNumeric(part) && whole !== 0) {
    return part / whole * 100;
  }
}



// WEBPACK FOOTER //
// ./src/utils/formatUtils.js